import "./Footer.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";

function Footer() {
  return (
    <div className="footer">
      <div className="top">
        <div>
          <h1>NK Travel</h1>
          <p>Choose your favourite destination.</p>
        </div>
        <div>
          <a href="!#">
            <i>
              <FacebookIcon />
            </i>
          </a>
          <a href="!#">
            <i>
              <InstagramIcon />
            </i>
          </a>
          <a href="!#">
            <i>
              <TwitterIcon />
            </i>
          </a>
        </div>
      </div>
      <div className="bottom">
        <div>
          <h4>Project</h4>
          <a href="!#">Changelog</a>
          <a href="!#">Status</a>
          <a href="!#">License</a>
          <a href="!#">All versions</a>
        </div>
        <div>
          <h4>Community</h4>
          <a href="!#">GitHub</a>
          <a href="!#">Issues</a>
          <a href="!#">Project</a>
          <a href="!#">Twitter</a>
        </div>
        <div>
          <h4>Help</h4>
          <a href="!#">Support</a>
          <a href="!#">Troubleshooting</a>
          <a href="!#">Contact Us</a>
        </div>
        <div>
          <h4>Others</h4>
          <a href="!#">Teams of Service</a>
          <a href="!#">Privacy</a>
          <a href="!#">Policy</a>
          <a href="!#">License</a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
